import PropTypes from "prop-types";
import React from "react";
import MenuLayer from "./menu-layer";
import { merge } from "glamor";
import { VIEWPORT_PHABLET, VIEWPORT_MOBILE } from "constants/media";
//import ChevronIcon from 'material-ui/svg-icons/navigation/chevron-right';
import ReactTransitionGroup from "react-transition-group/TransitionGroup";
import Timeout from "components/helpers/hoc/timeout";
const FirstChild = (props) => {
    const childrenArray = React.Children.toArray(props.children);
    return childrenArray[0] || null;
};

const touchDevice = "ontouchstart" in window || navigator.maxTouchPoints;
const isWindowsMachine = ["Win32", "Win64"].includes(navigator.platform); // Might be hacky

export default function (Component) {
    class MenuItemComponent extends Component {
        styles = merge({
            display: "block",
            position: "relative",
        });

        constructor(props) {
            super(props);
            this.state = this.state || {};
            this.state.hover = false;

            // No need to bind events on touch devices -- except for Surface tablets
            this.handleItemEnter = touchDevice && !isWindowsMachine ? undefined : this.handleItemEnter.bind(this);
            this.handleItemLeave = touchDevice && !isWindowsMachine ? undefined : this.handleItemLeave.bind(this);

            this.handleItemClick = this.handleItemClick.bind(this);
        }

        handleItemEnter() {
            this.props.clearTimeouts();
            this.props.setTimeout(() => {
                this.setState({ hover: true });
            }, 200);
        }

        handleItemLeave() {
            this.props.clearTimeouts();
            this.props.setTimeout(() => {
                this.setState({ hover: false });
            }, 150);
        }

        handleItemClick(e) {
            this.props.clearTimeouts();
            this.setState((state) => ({
                hover: touchDevice && isWindowsMachine ? !state.hover : false,
            }));
        }

        render() {
            const { viewport, children, style } = this.props;
            const { hover } = this.state;
            const isPhabletOrLess = viewport === VIEWPORT_MOBILE || viewport === VIEWPORT_PHABLET;

            return (
                <div
                    {...this.styles}
                    style={style}
                    onMouseEnter={this.handleItemEnter}
                    onMouseOver={this.handleItemEnter}
                    onMouseLeave={this.handleItemLeave}
                    onClick={this.handleItemClick}
                >
                    {super.render()}
                    {children && !isPhabletOrLess && (
                        <ReactTransitionGroup component={FirstChild}>
                            {hover && (
                                <MenuLayer type="menu" depth={1}>
                                    {children}
                                </MenuLayer>
                            )}
                        </ReactTransitionGroup>
                    )}
                    {isPhabletOrLess && (
                        <MenuLayer type="menu" depth={1}>
                            {children}
                        </MenuLayer>
                    )}
                </div>
            );
        }
    }

    MenuItemComponent.propTypes = {
        ...MenuItemComponent.propTypes,
        style: PropTypes.object,
    };

    MenuItemComponent.defaultProps = {
        ...MenuItemComponent.defaultProps,
        style: {},
    };

    return Timeout(MenuItemComponent);
}
